import axios from 'axios';
import Swal from 'sweetalert2';
import { CONFIG } from '../global-config';
import { getSessionId, saveSessionId } from '../utils/storage';

const axiosInstance = axios.create({
  baseURL: CONFIG.serverUrl,
  headers: {
    'Api-Key': CONFIG.apiKey,
    'Accept-Language': 'en',
    'Content-Type': 'application/json',
  },
});

function generateRandomSessionId(length = 32) {
  return [...Array(length)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join('');
}

axiosInstance.interceptors.request.use((config) => {
  let sessionId = getSessionId();

  if (!sessionId) {
    sessionId = generateRandomSessionId();
    saveSessionId(sessionId);
  }

  if (!config.headers) {
    config.headers = {};
  }

  config.headers['Session-Id'] = sessionId;
  return config;
});

export default axiosInstance; // ✅ this line must exist